import { render, staticRenderFns } from "./CommentaireDialog.vue?vue&type=template&id=62c6d030"
import script from "./CommentaireDialog.vue?vue&type=script&lang=js"
export * from "./CommentaireDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports